import React, { Suspense } from 'react';
import styled, { css } from 'styled-components';
import 'add-to-calendar-button';
import CalendarIcon from 'icons/src/Calendar';

const AddToCalendarComponent = ({
  className,
  startDate,
  startTime,
  endDate,
  endTime,
  title,
  description,
  location,
  buttonText,
}) => (
  <div className={className}>
    {!buttonText && (
      <Overlay>
        <CalendarIcon />
      </Overlay>
    )}
    <Suspense fallback={null}>
      <add-to-calendar-button
        buttonStyle="default"
        name={title}
        description={description}
        location={location}
        listStyle="modal"
        trigger="click"
        startDate={startDate}
        endDate={endDate}
        startTime={startTime}
        endTime={endTime}
        timeZone="UTC"
        hideTextLabelButton={!buttonText}
        label={buttonText}
        size="4"
        options="['Apple','Google','iCal','Microsoft365','Outlook.com','Yahoo']"
        language="nl"
        iCalFileName={title}
      />
    </Suspense>
  </div>
);

const Overlay = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 43.99px;
  height: 38.38px;
  background-color: ${({ theme }) => theme.secondaryColor};
  pointer-events: none;
  z-index: 2;
  border-radius: .1875rem;

  svg {
    width: 50%;
    color: white;
    pointer-events: none;
  }
`;

export default styled(AddToCalendarComponent)`
  ${({ buttonText }) => !buttonText && css`
    position: relative;
    display: flex;
    add-to-calendar-button {
      position: absolute;
      top: -5px;
      left: -5px;
      width: 47.62px;
      height: 42.01px;

      --btn-shadow: unset;
      --btn-shadow-hover: unset;
      --btn-shadow-active: unset;
      --btn-border: unset;
    }
  `}
`;
